import {
  CellCommand,
  SheetCommandType,
} from '../../../types/commands/sheetCommands/sheetCommands';
import { SheetManagementSet } from '../../../types/sheet/draft';
import { onCellInput } from '../../cells/cellInput';
import {
  applyDataValidation,
  removeDataValidation,
} from '../../cells/dataValidation';
import { applyNumberFormat } from '../../cells/numberFormat';
import { applyStyles } from '../../cells/styles';
import { createSheetDraft } from '../../sheet/updates';
import { getStaticSheetView } from './sheetCRUD';

export async function executeCellCommand(
  set: SheetManagementSet,
  command: CellCommand
) {
  const { sheetId, type } = command;

  const sheet = await createSheetDraft(sheetId, set);
  // const sheetView = getStaticSheetView(set, sheetId);

  if (!sheet) return;

  switch (type) {
    case SheetCommandType.CellInput:
      await onCellInput(set, sheet, command);
      break;
    case SheetCommandType.NumberFormat:
      await applyNumberFormat(set, sheet, command);
      break;
    case SheetCommandType.Styles:
      await applyStyles(set, sheet, command);
      break;
    case SheetCommandType.ApplyDataValidation:
      await applyDataValidation(set, sheet, command);
      break;
    case SheetCommandType.RemoveDataValidation:
      await removeDataValidation(set, sheet, command);
  }
}
